// Disable material design lite HTML5 validation on first page load
$(function () {
    componentHandler.registerUpgradedCallback('MaterialTextfield', function (textfield) {
        var input = $(textfield).find('.mdl-textfield__input');
        if (input.data('required') != null) {
            input.attr('required', true);
        }
    });
});

// Add '*' to required fields dynamically
$(function () {
    $('input[data-required=true]').each(function (index) {

        var input = $(this);
        var inputId = input.attr('id');

        var label = $('label[for=' + inputId + ']');

        var oldText = label.text();

        label.text(oldText + ' *');
    });
});

// Add non tracked form fields to the "Description" field
function combineDescription() {
    var callAt = document.getElementById('q8').value;
    var contactType = window.contactType;
    document.getElementById('q9').value = "\nCall at: " + callAt + "\nType: " + contactType;
}

// Process Zoho form redirect and show a snackbar with results
// Why 'r' function? See https://github.com/google/material-design-lite/issues/1995#issuecomment-217389362
r(function(){
    var redirectStatus = $.cookie('ZOHO_RESULT');
    if (!redirectStatus) {
        return;
    }

    var snackbarContainer = document.querySelector('#zoho-result-snackbar');
    var data;

    if (redirectStatus === 'OK') {
        data = {
            message: window.zoho_message_ok,
            timeout: 5000
        };
    } else {
        data = {
            message: window.zoho_message_error,
            timeout: 5000
        };
    }

    snackbarContainer.MaterialSnackbar.showSnackbar(data);
    $.removeCookie('ZOHO_RESULT');
});
function r(f){/in/.test(document.readyState)?setTimeout('r('+f+')',9):f()}
